import { IPopularSearchAttributesValue, IProductGroupSearchItem, ResultObjectType } from '@cbgms/api'

export enum VirtualSearchResultType {
  CallToActionSearchParts = 'CallToActionSearchParts',
  NoResults = 'NoResults',
  RepairTime = 'RepairTime'
}

export const EXPANDED = '__EXPANDED__'
export const SEP = '__SEP__'

export type ProductSearchResultType = ResultObjectType | VirtualSearchResultType

export interface RepairTimeChapter {
  ID: string
  Description: string
}
export interface IProductSearchResultProps {
  title: string
  Title?: string
  query: string
  clearQuery: () => void
  hasGroupHeader: boolean
  primaryAction: () => Promise<void>
  Score: number
  Type: ProductSearchResultType
  ProductGroup?: IProductGroupSearchItem
  TyreSize?: IPopularSearchAttributesValue
  ProductCount?: number
  Errors?: string[]

  RepairTimeChapter?: RepairTimeChapter
  onExpand?: (chapterId: string, searchQuery: string) => void
}
